<div class="p-1">
    <div
            class="interaction"
            [class.checked]="interaction.opened"
            [class.completed]="interaction.completed.status === 'success'"
            [class.deactivated]="interaction.comingSoon"
            [style.background-image]="'url(' + interaction.thumbnail +')'"
            (click)="goToInteraction()"
    >
    </div>
</div>

